<report-map class="report-map">
  <div id="map" class="map-container"></div>
  <script>
    import '../../../node_modules/@ambita/ambita-map/dist/ambita-map.css';
    import './reportMap.scss';
    import { init } from './reportMapController';

    init(this);
  </script>
</report-map>
